/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
	Container,
	CBody,
	BusinessDays,
	Title,
	BusinessVerificator,
} from "./style";
import { customStyles } from "../../style/selectStyles";
import { zoneData } from "../../helpers/selectTimezone.jsx";
import { Question } from "../../components/Question/index";

function AdvancedConfig(props) {
	const [slaDay, setSlaDay] = useState({
		monday: false,
		tuesday: false,
		wednesday: false,
		thursday: false,
		friday: false,
		sunday: false,
		saturday: false,
	});
	const [slaHour, setSlaHour] = useState({ start: 0, end: 0 });
	const [minutesMissingChat, setMinutesMissingChat] = useState();
	const [minutesReturnChat, setMinutesReturnChat] = useState();
	const [hoursEndChatWithOperator, setHoursEndChatWithOperator] = useState();
	const [gushType, setGushType] = useState({
		label: "Randômico",
		value: "random",
	});
	const [costTemplate, setTemplateCost] = useState(0);
	const [costInteractions, setInteractionsCost] = useState(0);
	const [gushForce, setGushForce] = useState();
	const [seriTimezone, setSeriTimezone] = useState();
	const [defaultNumber, setDefaultNumber] = useState("");
	const [checkNotInteractChat, setCheckNotInteractChat] = useState();
	const [
		checkNotInteractChatWithOperator,
		setCheckNotInteractChatWithOperator,
	] = useState();
	const [checkMissingChats, setCheckMissingChats] = useState();
	const [automaticGushPending, setAutomaticGushPending] = useState();

	const refreshTimeZone = (atualTimezone) => {
		const myCountry = zoneData.findIndex(
			(item) => item.label === props?.data?.timeZone
		);
		const myTimeZone = zoneData[myCountry]?.value.split(" ")[0];
		const operator = myTimeZone?.charAt(0);
		const time = myTimeZone?.charAt(1) + myTimeZone?.charAt(2);
		setSeriTimezone(myTimeZone);
		if (operator === "−") {
			let adaptedNumber =
				Number.parseInt(atualTimezone) - Number.parseInt(time);

			return Number.parseInt(adaptedNumber);
		}

		if (operator === "+") {
			let adaptedNumber =
				Number.parseInt(atualTimezone) + Number.parseInt(time);

			return Number.parseInt(adaptedNumber);
		}
	};

	const handleGushLabel = (gushType) => {
		const gushsTypes = {
			operator: "Proprietário",
			random: "Randômico",
			qttAttendance: "Quantidade de atendimentos",
		};
		return gushsTypes[gushType];
	};

	const refreshData = () => {
		setSlaDay({
			monday: props?.data?.businessDaysSLA?.monday
				? props?.data?.businessDaysSLA?.monday
				: false,
			tuesday: props?.data?.businessDaysSLA?.tuesday
				? props?.data?.businessDaysSLA?.tuesday
				: false,
			wednesday: props?.data?.businessDaysSLA?.wednesday
				? props?.data?.businessDaysSLA?.wednesday
				: false,
			thursday: props?.data?.businessDaysSLA?.thursday
				? props?.data?.businessDaysSLA?.thursday
				: false,
			friday: props?.data?.businessDaysSLA?.friday
				? props?.data?.businessDaysSLA?.friday
				: false,
			sunday: props?.data?.businessDaysSLA?.sunday
				? props?.data?.businessDaysSLA?.sunday
				: false,
			saturday: props?.data?.businessDaysSLA?.saturday
				? props?.data?.businessDaysSLA?.saturday
				: false,
		});

		setSlaHour({
			start:
				props?.data?.businessHoursSLA?.start !== undefined
					? refreshTimeZone(props?.data?.businessHoursSLA?.start)
					: 0,
			end:
				props?.data?.businessHoursSLA?.end !== undefined
					? refreshTimeZone(props?.data?.businessHoursSLA?.end)
					: 0,
		});

		setGushType({
			label: handleGushLabel(props?.data?.gushType),
			value: props?.data?.gushType ? props?.data?.gushType : "",
		});

		setGushForce(
			props.data.gushOperatorForce !== undefined
				? props.data.gushOperatorForce !== null && !props.data.gushOperatorForce
				: false
		);

		setMinutesReturnChat(
			props?.data?.minutesToReturnChatToOperatorInteraction
				? props?.data?.minutesToReturnChatToOperatorInteraction
				: 0
		);

		setCheckNotInteractChat(
			props?.data?.minutesToReturnChatToOperatorInteraction !== null &&
				props?.data?.minutesToReturnChatToOperatorInteraction !== undefined
				? true
				: false
		);

		setCheckNotInteractChatWithOperator(
			props?.data?.minutesToEndChatAfterInactivity !== null &&
				props?.data?.minutesToEndChatAfterInactivity !== undefined
				? true
				: false
		);

		setHoursEndChatWithOperator(
			props?.data?.minutesToEndChatAfterInactivity
				? props?.data?.minutesToEndChatAfterInactivity
				: 0
		);

		setMinutesMissingChat(
			props?.data?.minutesToTransferChatMissingResponse
				? props?.data?.minutesToTransferChatMissingResponse
				: 0
		);

		setCheckMissingChats(
			props?.data?.minutesToTransferChatMissingResponse !== null &&
				props?.data?.minutesToTransferChatMissingResponse !== undefined
				? true
				: false
		);

		setAutomaticGushPending(props?.data?.automaticGushPending ? true : false);

		setTemplateCost(props?.data?.costTemplate);
		setInteractionsCost(props?.data?.costInteractions);
		setDefaultNumber(props?.data?.defaultNumberToDispatch);
	};

	useEffect(() => {
		if (props.data) {
			refreshData();
		}
	}, [props.data]);

	useEffect(() => {
		if (props.canGetData[0] === true) {
			props.setAllData[1]({
				...props.setAllData[0],
				businessDaysSLA: slaDay,
				businessHoursSLA: slaHour,
				gushType: gushType.value,
				gushOperatorForce: gushForce,
				minutesToReturnChatToOperatorInteraction:
					Number.parseInt(minutesReturnChat),
				minutesToEndChatAfterInactivity: Number.parseInt(
					hoursEndChatWithOperator
				),
				minutesToTransferChatMissingResponse:
					Number.parseInt(minutesMissingChat),
				automaticGushPending: automaticGushPending,
				costInteractions,
				costTemplate,
				defaultNumberToDispatch: defaultNumber,
			});
			props.canGetData[1](false);
		}
	}, [props.canGetData[0]]);

	return (
		<Container>
			<>
				<CBody>
					<BusinessDays>
						<div style={{ marginBottom: "1rem", justifyContent: "left" }}>
							<label>
								{
									"Dias da semana habilitados para calculo do TME (Tempo médio de espera)"
								}
								<Question
									explanationMessage={
										"Somente as interações realizadas nos dias selecionados serão contabilizadas para o cálculo do TME (Tempo médio de espera)."
									}
								/>
							</label>
						</div>
						<div>
							<label htmlFor="slaMonday">{"Segunda-feira"}</label>
							<input
								type="checkbox"
								id="slaMonday"
								onChange={() => {
									setSlaDay({
										...slaDay,
										monday: !slaDay.monday,
									});
								}}
								checked={slaDay.monday}
							/>
							<label htmlFor="slaTuesday">{"Terça-feira"}</label>
							<input
								type="checkbox"
								id="slaTuesday"
								onChange={() => {
									setSlaDay({
										...slaDay,
										tuesday: !slaDay.tuesday,
									});
								}}
								checked={slaDay.tuesday}
							/>
							<label htmlFor="slaWednesday">{"Quarta-feira"}</label>
							<input
								type="checkbox"
								id="slaWednesday"
								onChange={() => {
									setSlaDay({
										...slaDay,
										wednesday: !slaDay.wednesday,
									});
								}}
								checked={slaDay.wednesday}
							/>
							<label htmlFor="slaThursday">{"Quinta-feira"}</label>
							<input
								type="checkbox"
								id="slaThursday"
								onChange={() => {
									setSlaDay({
										...slaDay,
										thursday: !slaDay.thursday,
									});
								}}
								checked={slaDay.thursday}
							/>
							<label htmlFor="slaFriday">{"Sexta-feira"}</label>
							<input
								type="checkbox"
								id="slaFriday"
								onChange={() => {
									setSlaDay({
										...slaDay,
										friday: !slaDay.friday,
									});
								}}
								checked={slaDay.friday}
							/>

							<label htmlFor="slaSaturday">{"Sábado"}</label>
							<input
								type="checkbox"
								id="slaSaturday"
								onChange={() => {
									setSlaDay({
										...slaDay,
										sunday: !slaDay.sunday,
									});
								}}
								checked={slaDay.sunday}
							/>
							<label htmlFor="daySaturday">{"Domingo"}</label>
							<input
								type="checkbox"
								id="daySaturday"
								onChange={() => {
									setSlaDay({
										...slaDay,
										saturday: !slaDay.saturday,
									});
								}}
								checked={slaDay.saturday}
							/>
						</div>
					</BusinessDays>
					<hr />
					{/* Finish Business TIme */}

					<BusinessDays notEvely>
						<div style={{ marginBottom: "1rem" }}>
							<label>
								{
									"Período habilitado para cálculo do TME (Tempo médio de espera)"
								}
								<Question
									explanationMessage={
										"Somente as interações realizadas no período selecionado serão contabilizadas para o cálculo do TME (Tempo médio de espera)."
									}
								/>
							</label>
						</div>
						<div>
							<label>{"De: "}</label>
							<input
								type="number"
								min={1}
								max={24}
								onChange={(e) => {
									setSlaHour({
										start: Number.parseInt(e.target.value),
										end: Number.parseInt(slaHour.end),
									});
									refreshTimeZone(e.target.value);
								}}
								value={slaHour.start}
							/>
							<label>{"Até: "}</label>
							<input
								type="number"
								min={1}
								max={24}
								onChange={(e) => {
									setSlaHour({
										start: Number.parseInt(slaHour.start),
										end: Number.parseInt(e.target.value),
									});
									refreshTimeZone(e.target.value);
								}}
								value={slaHour.end}
							/>
						</div>
					</BusinessDays>
					<hr />
					{/* FInish Business Time */}

					{/* FInish Last Interactions */}
					<>
						<Title>{"Regras de direcionamento de conversas"}</Title>
						<label>
							{"Regra de distribuição de conversas"}
							<Question
								explanationMessage={
									"<strong>Proprietário:</strong> As conversas serão direcionadas para o proprietário do contato. <br/>" +
									"<strong>Quantidade de atendimentos:</strong> As conversas serão distribuídas para os atendentes com menos conversas em andamento.<br/>" +
									"<strong>Randômico:</strong> As conversas serão distribuídas aleatoriamente para atendentes online."
								}
							/>
						</label>
						<div>
							<section>
								<Select
									styles={customStyles}
									placeholder={""}
									options={[
										{ label: "Proprietário", value: "operator" },
										{
											label: "Quantidade de atendimentos",
											value: "qttAttendance",
										},
										{ label: "Randômico", value: "random" },
									]}
									defaultValue={{
										label: handleGushLabel(props?.data?.gushType),
										value: props?.data?.gushType,
									}}
									onChange={(e) =>
										setGushType({
											label: e.label,
											value: e.value,
										})
									}
									value={{ label: gushType.label, value: gushType.value }}
									noOptionsMessage={() => ""}
								/>
							</section>
						</div>
						{gushType.value === "operator" && (
							<div
								style={{
									alignItems: "center",
									marginTop: "1.5rem",
								}}
							>
								<label>
									{
										"Caso o proprietário esteja offline, direcionar conversa para outro atendente online"
									}
								</label>
								<input
									type="checkbox"
									onChange={(e) => {
										setGushForce(e.target.checked);
									}}
									checked={gushForce}
								/>
							</div>
						)}
					</>
					<hr />

					{/* Last Interactions */}

					{/* Missing Response */}

					{gushForce === false && gushType.value === "operator" && (
						<>
							<BusinessVerificator evenly>
								<div>
									<Title>
										{"Tranferência de conversas sem interação do atendente"}
									</Title>
									<div>
										<label>
											{
												"Transferir conversa caso não haja interação do atendente"
											}
										</label>
										<input
											type="checkbox"
											onChange={(e) => setCheckMissingChats(e.target.checked)}
											checked={checkMissingChats}
										/>
									</div>
									<br />
									{checkMissingChats && (
										<div>
											<label>
												Tempo para transferência de conversas sem interação do
												atendente(minutos)
											</label>
											<input
												type="number"
												onChange={(e) => setMinutesMissingChat(e.target.value)}
												value={minutesMissingChat}
											/>
										</div>
									)}
								</div>
							</BusinessVerificator>
							<hr />
						</>
					)}

					{/* Return Operator */}

					<BusinessVerificator notEvely>
						<Title style={{ marginBottom: 0 }}>
							{
								"Direcionar resposta para atendente que interagiu com o contato(Envio de mensagem pela timeline)"
							}
						</Title>
						<span style={{ fontSize: "12px", marginBottom: "1rem" }}>
							Ao ativar essa opção, quando um atendente envia uma mensagem para
							um contato as regras de direcionamento de conversas serão
							ignoradas.
						</span>
						<div>
							<div>
								<label>
									{"Ativar fidelização de contato"}
									<Question
										explanationMessage={
											"Caso um atendente/operador interaja com um contato,se marcado, abre-se uma janela de tempo onde qualquer interação do contato será direcionada para o mesmo atendente/operador"
										}
									/>
								</label>
								<input
									type="checkbox"
									onChange={(e) => setCheckNotInteractChat(e.target.checked)}
									checked={checkNotInteractChat}
								/>
							</div>
							<br />
							{checkNotInteractChat && (
								<div>
									<label>
										Janela de tempo para transferência de atendimento(minutos):
									</label>
									<input
										type="number"
										onChange={(e) => setMinutesReturnChat(e.target.value)}
										value={minutesReturnChat}
									/>
								</div>
							)}
						</div>
					</BusinessVerificator>

					<hr />

					<BusinessVerificator>
						<Title>Finalização automática de conversas</Title>
						<div>
							<div>
								<label>
									Finalizar conversas automaticamente quando não houver
									interações
									<Question explanationMessage="Caso esse campo esteja marcado, todas as conversas sem interações do contato e do atendente, serão finalizadas automaticamente após o tempo determinado." />
								</label>
								<input
									type="checkbox"
									onChange={(e) => {
										if (!e.target.checked) {
											setHoursEndChatWithOperator(null);
										}
										setCheckNotInteractChatWithOperator(e.target.checked);
									}}
									checked={checkNotInteractChatWithOperator}
								/>
							</div>
							<br />
							{checkNotInteractChatWithOperator && (
								<div>
									<label>
										Tempo para finalizar conversas automaticamente (horas)
									</label>
									<input
										type="number"
										onChange={(e) =>
											setHoursEndChatWithOperator(e.target.value)
										}
										value={hoursEndChatWithOperator}
									/>
								</div>
							)}
						</div>
					</BusinessVerificator>

					<hr />
					<BusinessVerificator>
						<Title>Transbordo automático para conversas pendentes</Title>
						<span style={{ fontSize: "12px", marginBottom: "1rem" }}>
							Ao ativar essa opção, quando um atendente ficar online no Hubspot
							(Whatsapp), todas as conversas pendentes serão atribuídas à ele.
							<br />
							Caso contrário, todas as conversas pendentes serão mostradas para
							todos os operadores (do mesmo setor que o número do whatsapp).
							<br />O atendente escolherá se quer ou não atribuir a conversa a
							ele.
						</span>
						<div>
							<div>
								<label>Ativar atribuíção automática</label>
								<input
									type="checkbox"
									onChange={(e) => setAutomaticGushPending(e.target.checked)}
									checked={automaticGushPending}
								/>
							</div>
						</div>
					</BusinessVerificator>
					<hr />
					<BusinessVerificator>
						<Title>Número padrão para disparos</Title>
						<div>
							<span style={{ fontSize: "12px", marginBottom: "1rem" }}>
								Caso o atendente seja de outro setor e, por exemplo, há apenas
								um número e este número está em outro setor, o envio do disparo
								será realizado atraves<br></br>
								deste número padrão definido.
								<br></br>
								Caso não haja este número, um erro será mostrado ao atendente e
								a mensagem não será enviada.
							</span>
							<div className="default-number" style={{ marginTop: 15 }}>
								<label>Número do Whatsapp</label>
								<input
									onChange={(e) => setDefaultNumber(e.target.value)}
									value={defaultNumber}
									placeholder="5519912345678"
								/>
							</div>
						</div>
					</BusinessVerificator>
					<hr />
					<BusinessVerificator>
						<Title>Custo por interações - Gupshup</Title>
						<div>
							<div>
								<label>Custo por template enviado</label>
								<input
									type="number"
									onChange={(e) => setTemplateCost(e.target.value)}
									value={costTemplate}
								/>
							</div>
							<div style={{ marginTop: 15 }}>
								<label>Custo por mensagem trocada</label>
								<input
									type="number"
									onChange={(e) => setInteractionsCost(e.target.value)}
									value={costInteractions}
								/>
							</div>
						</div>
					</BusinessVerificator>
				</CBody>
			</>
		</Container>
	);
}
export default AdvancedConfig;
